import React, { useState } from 'react';
import Button from './Button';
import Icon from '../AppIcon';
import RegionSelector from './RegionSelector';
import { appendTrackingParams } from '../../utils/tracking';

const regionDark =
  '[&_label]:text-white/70 [&_select]:border-white/30 [&_select]:bg-white/10 [&_select]:text-white [&_select]:backdrop-blur-sm';

/**
 * Sign in / app CTAs + region (legacy accounting marketing header).
 * @param {{ variant?: 'desktop' | 'mobile' }} props
 */
const AccountingMarketingNavActions = ({ variant = 'desktop' }) => {
  const [ctaPressed, setCtaPressed] = useState(false);
  const appUrl = (import.meta.env.VITE_APP_URL || 'https://app.neevii.com').replace(/\/$/, '');
  const openApp = () => {
    const region = typeof window !== 'undefined' ? localStorage.getItem('neevii-website-region') : null;
    const url = region === 'intl' ? `${appUrl}/login?country=XX` : appUrl;
    window.location.href = appendTrackingParams(url);
  };

  if (variant === 'mobile') {
    return (
      <>
        <div className={`mt-4 ${regionDark}`}>
          <RegionSelector />
        </div>
        <div className="mt-6 space-y-3 border-t border-white/15 pt-4">
          <Button
            variant="ghost"
            fullWidth
            onClick={openApp}
            className="justify-start border border-[#ffbe33]/70 text-[#ffbe33] hover:bg-white/10"
          >
            <Icon name="LogIn" size={18} className="mr-3" />
            Sign In
          </Button>
          <Button
            variant="default"
            fullWidth
            onClick={openApp}
            className="bg-[#cf8f1a] font-semibold uppercase tracking-wide text-black shadow-lg hover:bg-[#e0a322]"
          >
            <Icon name="Zap" size={18} className="mr-2" />
            See How It Works
          </Button>
        </div>
      </>
    );
  }

  return (
    <div className="flex items-center gap-2 lg:gap-3">
      <div className={`hidden lg:block ${regionDark}`}>
        <RegionSelector />
      </div>
      <div
        className={`flex items-center space-x-0 ${ctaPressed ? 'rounded-md ring-2 ring-[#ffbe33] ring-offset-2 ring-offset-black/40' : ''}`}
        onMouseDown={() => setCtaPressed(true)}
        onMouseUp={() => setCtaPressed(false)}
        onMouseLeave={() => setCtaPressed(false)}
        onTouchStart={() => setCtaPressed(true)}
        onTouchEnd={() => setCtaPressed(false)}
        onTouchCancel={() => setCtaPressed(false)}
      >
        <Button
          variant="ghost"
          size="sm"
          onClick={openApp}
          className={`border border-[#ffbe33]/80 bg-transparent font-semibold uppercase tracking-wide text-[#ffbe33] hover:bg-white/10 hover:text-[#ffbe33] ${ctaPressed ? 'ring-2 ring-[#ffbe33] ring-offset-2 ring-offset-black/50' : ''}`}
          aria-label="Sign In"
        >
          Sign In
        </Button>
        <Button
          variant="default"
          size="sm"
          onClick={openApp}
          className="bg-[#cf8f1a] font-semibold uppercase tracking-wide text-black shadow-lg hover:bg-[#e0a322]"
          aria-label="See How It Works"
        >
          See How It Works
        </Button>
      </div>
    </div>
  );
};

export default AccountingMarketingNavActions;
